import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import StickyCTA from "@/components/layout/StickyCTA";

export const Layout = () => {
  return (
    <div className="relative z-0 min-h-screen bg-[#0E0F10]">
      <Header />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
};

export default Layout;
